import { Model } from '@danangelus/ngx-app-core'

/**
 * Class representing a user.
 */
export class User extends Model {

    dn: string | undefined
    userId: string | undefined
    subId: string | undefined
    id: string | undefined
    name: string | undefined
    email: string | undefined
    password: string | undefined
    language: string | undefined
    preferredLanguage: string | undefined
    distributorCode: string | undefined
    dealerNo: string | undefined
    dealerName: string | undefined
    street: string | undefined
    city: string | undefined
    postcode: string | undefined
    stationCode: string | undefined
    phone: string | undefined
    locked: boolean | undefined
    mfaOption: string | undefined
    verified: boolean | undefined
    missingDefaultMfa: boolean | undefined
    passwordExpired: boolean | undefined
    rawAccountExpiration: string | undefined
    accountExpiration: number | undefined
    rawPasswordLastSet: string | undefined
    passwordLastSet: number | undefined

    ssoTicketId: string | undefined
    groups: string[] = []

    constructor(user?: any) {
        super(user)

        if (user?.groups?.length > 0) {
            this.groups = user.groups
        }
        this.locked = user?.locked == true || user?.locked === 'TRUE' || user?.isLocked === 'TRUE'
        this.groups = user?.groups
    }

    getId() {
        return this.userId || this.id
    }

}
